export const IndividualTaskQuota = 'https://ik.imagekit.io/duckbill/prod/Task/individual-quota?updatedAt=1724257578984';
export const DraftsIllustration =
  'https://ik.imagekit.io/duckbill/prod/Task/drafts-illustration?updatedAt=1724262561170';
export const BeforeMigrationDateTaskQuota =
  'https://ik.imagekit.io/duckbill/prod/Task/image.png?updatedAt=1728423030056';
